window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.browseCourses = window.locales.am.browseCourses || {};window.locales.am.browseCourses.browseCourses = window.locales.am.browseCourses.browseCourses || {};window.locales.am.browseCourses.browseCourses = {...window.locales.am.browseCourses.browseCourses, ...{
    "coursesTitle": "ኮርሶች",           
    "search": "ፈልግ",           
    "searchPlaceholder": "ኮርሶችን፣ ትምህርቶችን፣ እና ቁልፍ ቃላትን ይፈልጉ",           
    "filterByTopic": "በርዕስ ያጣሩ",           
    "filterByProgress": "በሂደት ያጣሩ",           
    "filterByStatus": "በሁኔታ ያጣሩ",           
    "anyTopic": "ማንኛዉም ርዕስ",           
    "anyProgress": "ማንኛዉም ሂደት",           
    "allCourses": "ሁሉም ኮርሶች",           
    "not_started": "አልተጀመረም",           
    "in_progress": "በሂደት ላይ",           
    "completed": "ተጠናቋል",           
    "any_status": "ማንኛውም ሁኔታ",           
    "available": "ይገኛል",           
    "new_courses": "አዲስ",           
    "updated": "የዘመነ",           
    "beta": "ቤታ",           
    "coming_soon": "በቅርቡ ይመጣል",           
    "elective": "ተመራጭ",           
    "setFiltersTitle": "ማጣሪያዎችን ያዘጋጁ",           
    "saveAndClose": "ያስቀምጡ እና ይዝጉ",           
    "noContentFound": "ይቅርታ! የእርስዎን ማጣሪያዎች የሚዛመድ ምንም ይዘት አልተገኘም።",           
    "reset": "ፍለጋ እና ማጣሪያዎችን እንደገና አስጀምር",           
    "flatList": "ዝርግ ዝርዝር",           
    "groupedByTopic": "በርዕስ የተቧደኑ",           
    "otherTopic": "ሌላ",           
    "newBadge": "አዲስ",           
    "updatedBadge": "የዘመነ",           
    "betaBadge": "ቤታ",           
    "comingSoonBadge": "በቅርቡ ይመጣል",           
    "comingSoonModal": "የ{brandName} የይዘት ቡድን በ<strong>{title}</strong>ላይ ጠንክሮ እየሰራ ነው!<br/><br/> ኮርሱ ሲኖር ማሳወቂያ እንዲደርስዎት ይፈልጋሉ?",           
    "notify": "ያሳውቁኝ",           
    "cancel": "ሰርዝ",           
    "letYouKnow": "አመሰግናለሁ! ይህ ኮርስ ሲኖር እናሳውቅዎታለን።",           
    "lessonCompletionCount": "ከ {count} {completed} ተጠናቋል",
    "somethingWentWrong": "የሆነ ችግር ተፈጥሯል። እባክዎ እንደገና ይሞክሩ።",
    "retry": "እንደገና ሞክር"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.browseCourses = window.locales.ar.browseCourses || {};window.locales.ar.browseCourses.browseCourses = window.locales.ar.browseCourses.browseCourses || {};window.locales.ar.browseCourses.browseCourses = {...window.locales.ar.browseCourses.browseCourses, ...{
    "coursesTitle": "الدورات",
    "search": "البحث",           
    "searchPlaceholder": "ابحث عن الدورات، الدروس، والمصطلحات الأساسية",           
    "filterByTopic": "التصفية حسب الموضوع",           
    "filterByProgress": "التصفية حسب التقدم",           
    "filterByStatus": "التصفية حسب الحالة",           
    "anyTopic": "أي موضوع",           
    "anyProgress": "أي تقدم",           
    "allCourses": "جميع الدورات",           
    "not_started": "لم يتم البدء",           
    "in_progress": "قيد التنفيذ",           
    "completed": "مكتملة",           
    "any_status": "أية حالة",           
    "available": "متاح",           
    "new_courses": "جديد",           
    "updated": "تم التحديث",           
    "beta": "الإصدار التجريبي",           
    "coming_soon": "قريباً",           
    "elective": "اختياري",
    "setFiltersTitle": "تعيين التصفيات",           
    "saveAndClose": "حفظ وغلق",           
    "noContentFound": "عذراً! لم يتم العثور على أي محتوى يطابق تصفياتك.",           
    "reset": "إعادة البحث والتصفية",           
    "flatList": "قائمة مسطحة",           
    "groupedByTopic": "مجمّعة حسب الموضوع",           
    "otherTopic": "أخرى",           
    "newBadge": "جديد",           
    "updatedBadge": "تم التحديث",           
    "betaBadge": "BETA",           
    "comingSoonBadge": "قريباً",           
    "comingSoonModal": "فريق المحتوى {brandName} يعمل بجد على <strong>{title}</strong> ! <br/><br/> هل ترغب في أن يتم إعلامك عند توفر هذه الدورة التدريبية؟",
    "notify": "أعلمني",           
    "cancel": "إلغاء",           
    "letYouKnow": "شكراً لك! إننا سوف نعلمك متى تكون هذه الدورة متاحة.",           
    "lessonCompletionCount": "{completed} من {count} درسًا مكتملًا",
    "somethingWentWrong": "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
    "retry": "إعادة المحاولة"
}
};window.locales.en = window.locales.en || {};window.locales.en.browseCourses = window.locales.en.browseCourses || {};window.locales.en.browseCourses.browseCourses = window.locales.en.browseCourses.browseCourses || {};window.locales.en.browseCourses.browseCourses = {...window.locales.en.browseCourses.browseCourses, ...{
    "coursesTitle": "COURSES",
    "search": "Search",
    "searchPlaceholder": "Search Courses, Lessons, and Key Terms",
    "filterByTopic": "Filter By Topic",
    "filterByProgress": "Filter By Progress",
    "filterByStatus": "Filter By Status",
    "anyTopic": "Any Topic",
    "anyProgress": "Any Progress",
    "allCourses": "All Courses",
    "not_started": "Not Started",
    "in_progress": "In Progress",
    "completed": "Completed",
    "any_status": "Any Status",
    "available": "Available",
    "new_courses": "New",
    "updated": "UPDATED",
    "beta": "BETA",
    "coming_soon": "Coming Soon",
    "elective": "ELECTIVE",
    "setFiltersTitle": "Set Filters",
    "saveAndClose": "Save and Close",
    "noContentFound": "Sorry! No content found matching your filters.",
    "reset": "RESET SEARCH & FILTERS",
    "flatList": "Flat List",
    "groupedByTopic": "Grouped by Topic",
    "otherTopic": "Other",
    "newBadge": "NEW",
    "updatedBadge": "UPDATED",
    "betaBadge": "BETA",                                                           
    "comingSoonBadge": "COMING SOON",
    "comingSoonModal": "The {brandName} content team is hard at work on <strong>{title}</strong>!<br/><br/>Would you like to be notified when this course is available?",
    "notify": "NOTIFY ME",
    "cancel": "CANCEL",
    "letYouKnow": "Thanks! We'll let you know when this course is available.",
    "lessonCompletionCount": "{completed} of {count} lessons completed",
    "somethingWentWrong": "Something went wrong. Please try again.",
    "retry": "Retry"
}
};window.locales.es = window.locales.es || {};window.locales.es.browseCourses = window.locales.es.browseCourses || {};window.locales.es.browseCourses.browseCourses = window.locales.es.browseCourses.browseCourses || {};window.locales.es.browseCourses.browseCourses = {...window.locales.es.browseCourses.browseCourses, ...{
    "coursesTitle": "CURSOS",
    "search": "Buscar",           
    "searchPlaceholder": "Buscar cursos, lecciones, y términos claves",           
    "filterByTopic": "Filtrar por tema",           
    "filterByProgress": "Filtrar por progreso",           
    "filterByStatus": "Filtrar por estado",           
    "anyTopic": "Cualquier tema",           
    "anyProgress": "Cualquier progreso",           
    "allCourses": "Todos los cursos",           
    "not_started": "No empezado",           
    "in_progress": "En progreso",           
    "completed": "Terminado",           
    "any_status": "Cualquier estado",           
    "available": "Disponible",           
    "new_courses": "Nuevos",           
    "updated": "ACTUALIZADO",           
    "beta": "BETA",           
    "coming_soon": "¡Próximamente!",           
    "elective": "ELECTIVO",
    "setFiltersTitle": "Establecer filtros",           
    "saveAndClose": "Guardar y cerrar",           
    "noContentFound": "¡Lo lamentamos! No se han encontrado contenidos que coincidan con tus filtros.",           
    "reset": "RESTAURAR BÚSQUEDA Y FILTROS",           
    "flatList": "Lista plana",           
    "groupedByTopic": "Agrupado por Topic",           
    "otherTopic": "Otro",           
    "newBadge": "NUEVO",           
    "updatedBadge": "ACTUALIZADO",           
    "betaBadge": "BETA",           
    "comingSoonBadge": "¡PRÓXIMAMENTE!",           
    "comingSoonModal": "¡El equipo de contenido de {brandName} está trabajando arduamente en <strong>{title}</strong> ! <br/><br/> ¿Quieres que te avisemos cuando este curso esté disponible?",
    "notify": "NOTIFICARME",           
    "cancel": "CANCELAR",           
    "letYouKnow": "¡Gracias! Nosotros te avisaremos cuando este curso esté disponible.",           
    "lessonCompletionCount": "{completed} de {count} lecciones completadas",
    "somethingWentWrong": "Algo salió mal. Inténtalo de nuevo.",
    "retry": "Reintentar"
}
};window.locales.it = window.locales.it || {};window.locales.it.browseCourses = window.locales.it.browseCourses || {};window.locales.it.browseCourses.browseCourses = window.locales.it.browseCourses.browseCourses || {};window.locales.it.browseCourses.browseCourses = {...window.locales.it.browseCourses.browseCourses, ...{
    "coursesTitle": "CORSI",
    "search": "Cerca",           
    "searchPlaceholder": "Cerca Corsi, Lezioni e Parole chiave",           
    "filterByTopic": "Filtra per Argomento",           
    "filterByProgress": "Filtra per Progresso",           
    "filterByStatus": "Filtra per Stato",           
    "anyTopic": "Qualsiasi Argomento",           
    "anyProgress": "Qualsiasi Progresso",           
    "allCourses": "Tutti i Corsi",           
    "not_started": "Non iniziato",           
    "in_progress": "In corso",           
    "completed": "Completato",           
    "any_status": "Qualsiasi Stato",           
    "available": "Disponibile",           
    "new_courses": "Nuovo",           
    "updated": "AGGIORNATO",           
    "beta": "BETA",           
    "coming_soon": "In arrivo",           
    "elective": "ELETTIVO",
    "setFiltersTitle": "Imposta Filtri",           
    "saveAndClose": "Salva e Chiudi",           
    "noContentFound": "Siamo spiacenti! Non è stato trovato alcun contenuto che corrisponda ai tuoi filtri.",           
    "reset": "REIMPOSTA RICERCA E FILTRI",           
    "flatList": "Elenco Semplice",           
    "groupedByTopic": "Raggruppati per Argomento",           
    "otherTopic": "Altro",           
    "newBadge": "NUOVO",           
    "updatedBadge": "AGGIORNATO",           
    "betaBadge": "BETA",           
    "comingSoonBadge": "IN ARRIVO",           
    "comingSoonModal": "Il team di contenuti {brandName} è al lavoro su <strong>{title}</strong> ! <br/><br/> Vuoi essere avvisato quando questo corso è disponibile?",
    "notify": "NOTIFICAMI",           
    "cancel": "ANNULLA",           
    "letYouKnow": "Grazie! Ti informeremo quando questo corso sarà disponibile.",           
    "lessonCompletionCount": "{completed} di {count} lezioni completate",
    "somethingWentWrong": "Qualcosa è andato storto. Riprova.",
    "retry": "Riprova"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.browseCourses = window.locales.zh.browseCourses || {};window.locales.zh.browseCourses.browseCourses = window.locales.zh.browseCourses.browseCourses || {};window.locales.zh.browseCourses.browseCourses = {...window.locales.zh.browseCourses.browseCourses, ...{
    "coursesTitle": "课程",           
    "search": "搜索",           
    "searchPlaceholder": "搜索课程、课业和关键术语",           
    "filterByTopic": "按主题筛选",           
    "filterByProgress": "按进度筛选",           
    "filterByStatus": "按状态筛选",           
    "anyTopic": "任何主题",           
    "anyProgress": "任何进度",           
    "allCourses": "所有课程",           
    "not_started": "未开始",           
    "in_progress": "正在进行",           
    "completed": "已完成",           
    "any_status": "任何状态",           
    "available": "可用",           
    "new_courses": "新增",           
    "updated": "已更新",           
    "beta": "测试版",           
    "coming_soon": "即将推出",           
    "elective": "选修",           
    "setFiltersTitle": "设置筛选条件",           
    "saveAndClose": "保存并关闭",           
    "noContentFound": "抱歉！未找到与您的筛选条件匹配的内容。",           
    "reset": "重置搜索和筛选条件",           
    "flatList": "按字母顺序",           
    "groupedByTopic": "按主题分组",           
    "otherTopic": "其他",           
    "newBadge": "新增",           
    "updatedBadge": "已更新",           
    "betaBadge": "测试版",           
    "comingSoonBadge": "即将推出",           
    "comingSoonModal": "{brandName}内容团队正在努力解决<strong>{title}</strong>！<br/><br/>课程开启后，是否需要我们向你发送通知？",           
    "notify": "通知我",           
    "cancel": "取消",           
    "letYouKnow": "谢谢！我们将在此课程可用时告诉您。",           
    "lessonCompletionCount": "已完成{completed}/{count}节",
    "somethingWentWrong": "出现错误，请重试。",
    "retry": "重试"
}
};